export default "__VITE_ASSET__DREQH$av__"